// UPRAVIŤ ZÁKAZKU V3 — na spoločnom FormularV3 (hlavná session 29. 9. 2026): krok Údaje + krok Súhrn zmien „pole: staré → nové“ (129.1: na server ide len zmenené pole)
// Ústava: 23.3.A MKsoft zákazka len na čítanie (mení sa Spárovať/Zmeniť) · 23.2.A.3 Stav len na čítanie · 0.R zmena segmentu len admin/majiteľ/office · 53.7 zámok rieši volajúci · 131 V3
import React, { useEffect, useMemo, useState } from 'react'
import FormularV3 from './FormularV3.jsx'
import { sekcieUdaje } from './NovaZakazkaV3.jsx'
import { fetchAuth, fetchAuthJSON } from '../auth/fetchAuth.js'
import { useToast } from './Toast.jsx'
import { SK } from '../theme.js'

export default function EditZakazkaV3({ open = true, project, customers = [], user, onClose, onSaved, onAkcia }) {
  const toast = useToast()
  const [majstri, setMajstri] = useState([])
  const [projekty, setProjekty] = useState([])
  useEffect(() => {
    if (!open) return
    fetchAuthJSON('/api/employees').then(e => setMajstri((Array.isArray(e) ? e : []).filter(x => ['majster', 'majiteľ', 'technik'].includes((x.role || '').toLowerCase())))).catch(() => {})
    fetchAuthJSON('/api/projects').then(p => setProjekty(Array.isArray(p) ? p : [])).catch(() => {})
  }, [open])
  const custOpts = useMemo(() => customers.map(c => ({ value: c.id, label: `${c.name} (${c.id})${c.ico ? ' · IČO ' + c.ico : ''}` })), [customers])
  const smieSegment = ['admin', 'owner', 'office_manager'].includes(String((user && user.role) || ''))
  const kroky = useMemo(() => [
    { id: 'udaje', nazov: 'Údaje', hint: 'Zmeň, čo treba — na ďalšom kroku uvidíš len zmenené polia (staré → nové).', tlacidlo: 'Súhrn zmien →', sekcie: sekcieUdaje({ projekty, custOpts, majstri, edit: { smieSegment } }) },
    { id: 'suhrn', nazov: 'Súhrn zmien', typ: 'rozdiely', tlacidlo: 'Uložiť zmeny' },
  ], [projekty, custOpts, majstri, smieSegment])

  async function uloz(h, { rozdiely, povodne }) {
    try {
      const payload = { updated_at: project.updated_at }
      ;(rozdiely || []).forEach(r => { payload[r.key] = h[r.key] })   // len zmenené polia (129.1)
      if (payload.zmluva_hodnota !== undefined) payload.zmluva_hodnota = SK.parse(String(payload.zmluva_hodnota)) || 0
      const r = await fetchAuth(`/api/projects/${encodeURIComponent(project.id)}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      if (r.status === 409) { const j = await r.json().catch(() => ({})); toast.error(j.message || 'Konflikt: niekto iný zmenil tieto údaje. Zatvor a otvor znova.'); return false }
      if (!r.ok) { const j = await r.json().catch(() => ({})); toast.error('Uloženie zlyhalo: ' + (j.error || j.message || r.status)); return false }
      const stare = {}, nove = {}; (rozdiely || []).forEach(r => { stare[r.key] = (povodne && povodne[r.key] !== undefined && povodne[r.key] !== null) ? povodne[r.key] : ''; nove[r.key] = payload[r.key] })
      onSaved && onSaved({ zmenene: (rozdiely || []).length, stare, nove })   // stare/nove pre Vrátiť (2 min)
      return true
    } catch (e) { toast.error('Chyba: ' + e.message); return false }
  }
  const akcie = [
    { label: String(project.zakazka_code || project.mksoft_cislo || '').trim() ? 'Zmeniť spárovanie s MKsoftom' : 'Spárovať s MKsoftom', onClick: () => onAkcia && onAkcia('mksoft') },
    { label: 'Otvoriť kartu zákazky', onClick: () => onAkcia && onAkcia('karta') },
  ]
  if (!open) return null
  return <FormularV3 open={open} zaznam={project} kroky={kroky} nazovZaznamu="zákazku" titul={'Upraviť zákazku — ' + project.id + ' ' + (project.name || '')} onUloz={uloz} onZavri={onClose} akcie={akcie} />
}
